import type { DataGridRowSelectionState } from '@ibsys/kit';

/** Отмеченные строки грида — идентификаторами записей */
export const getSelectedRowIds = (rowSelection: DataGridRowSelectionState): number[] =>
  Object.entries(rowSelection)
    .filter(([, isSelected]) => isSelected)
    .map(([rowId]) => Number(rowId));

/** Отметки строк грида по идентификаторам записей */
export const toRowSelection = (ids: number[]): DataGridRowSelectionState =>
  Object.fromEntries(ids.map((id) => [String(id), true]));
